<template lang="pug">
.form-code.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.code" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.code }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="code" title="Nombre Del Código")

      .input-container.arrow
        select.select(v-model="dataForm.type" autocomplete="ño" @change="initDiscounts" required)
          option(v-for="type in types" :value="type") {{ type }}
        label.label(:class="{ show: dataForm.type }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="type" title="Tipo")

      transition-group.w100(name="slide-fade")
        .input-container(v-if="!dataForm.type || dataForm.type === 'percent'" key="percent")
          input.input(v-model.number="dataForm.percent" autocomplete="ño" type="number" min="1" max="100" required)
          label.label(:class="{ show: dataForm.percent >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="percent" title="Porcentaje")
        .input-container(v-else key="value")
          input.input(v-model.number="dataForm.value" autocomplete="ño" type="number" min="1" max="200000" required)
          label.label(:class="{ show: dataForm.value >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="value" title="Valor")

      .input-container.arrow
        select.select(v-model="dataForm.brand"  autocomplete="ño" required)
          option(value="")
          option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
        label.label(:class="{ show: dataForm.brand }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="brand" title="Marca")

      .input-container
        input.input(v-model.number="dataForm.quantity" autocomplete="ño" type="number" min="1")
        label.label(:class="{ show: dataForm.quantity > 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="quantity" title="Cantidad disponible (vacío = ilimitado)")

      p.remaining-info(v-if="fillData && dataOriginal.quantity != null") Restantes: {{ dataOriginal.remaining }} / {{ dataOriginal.quantity }}

      .input-container
        input.input(v-model="dataForm.phone" autocomplete="ño" type="tel")
        label.label(:class="{ show: dataForm.phone }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="phone" title="Teléfono autorizado (vacío = cualquiera)")

      .checkbox-section
        .input-container-checkbox
          label.label-checkbox(:for="`active${dataForm.code}`")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="active" title="Activo")
            input.input-checkbox(v-model="dataForm.active" :id="`active${dataForm.code}`" type="checkbox")
            .checkmark

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteCode")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlCode from '@/graphql/code'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import mFilters from '@/mixins/filters'

export default {
  name: 'FormCode',

  mixins: [mForm, mDB, mFilters],

  components: { shDeleteButton, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        code: '',
        type: '',
        value: 0,
        percent: 0,
        active: true,
        brand: '',
        quantity: null,
        phone: ''
      },
      types: ['percent', 'value'],
      resolver: 'code',
      key: 'code',
      gql: gqlCode
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    initDiscounts () {
      this.dataForm.value = 0
      this.dataForm.percent = 0
    },

    sendForm () {
      if (!this.fillData) {
        this.newCode()
      } else {
        this.updateCode()
      }
    },

    newCode () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateCode () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteCode () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-code
  position relative

.remaining-info
  font-size 1.1rem
  color #616161
  margin .5rem 0
</style>



// WEBPACK FOOTER //
// src/components/pages/code/Form.vue